export default {"src":"/_next/static/media/Solution2.65671ea6.svg","height":49,"width":49};